export default {
  equipment: {
    studyMachine: '学习机',
    deliveryCreation: '发货创建',
    deliveryDetail: '发货详情',
    childrenDevice: '子女样机',
    barterManage: '换货管理',
    takeDelivery: '仓内提货',
    prototypeManagement: '样机管理',
    deviceSN: '设备SN码',
    deviceName: '设备名称',
    agent: '代理商',
    createTime: '创建时间',
    operation: '操作',
    detail: '详情',
    cancel: '取消',
    confirm: '确定',
    delete: '删除',
    submit: '提交',
    remark: '备注',
    yes: '是',
    no: '否',
    latest: '最新',
    assignDistributor: '分配分销商',
    assignCounter: '分配柜台',
    batchModifyAgent: '批量修改代理商',
    modifyAgent: '修改代理商',
    changeBindPhone: '手机号换绑',
    logisticsDetail: '物流详情',
    companyName: '公司名称',
    pleaseSelectCompany: '请选择公司',
    query: '查询',
    studyMachineRemark: '学习机备注',
    machineAccountCode: '学习机账户编号',
    machineAccount: '学习机账户',
    originalAgentId: '原代理商ID',
    originalAgentName: '原代理商名称',
    newAgentId: '新代理商ID',
    newAgentName: '新代理商名称',
    pleaseFillNewAgentId: '请填写新代理商ID',
    pleaseFillPurchaseOrder: '请填写采购单号',
    pleaseSelect: '请选择',
    isMoveAccount: '是否迁移账户',
    batchAssignDistributor: '批量分配分销员',
    assignTo: '分配给：',
    pleaseSelectDistributor: '请选择分销员',
    assignToCounter: '分配到：',
    pleaseSelectCounter: '请选择柜台',
    pleaseSelectMachine: '请选择学习机',
    agentIdSameTip: '代理商ID新旧不能一样',
    sendCode: '发送验证码',
    resend: '重新发送',
    secondsResend: '{n}秒后重新发送',
    secondsResendEn: '{n}s',
    verificationCode: '验证码',
    originalPhone: '原手机号',
    pleaseFillOriginalPhone: '请填写原手机号',
    pleaseFillNewPhone: '请填写新手机号',
    verifyCode: '验证码',
    pleaseFillVerificationCode: '请填写验证码',
    nextStep: '下一步',
    bindSuccess: '换绑成功',
    bindFail: '换绑失败',
    assignSuccess: '分配成功',
    assignFail: '分配失败',
    modifySuccess: '修改成功',
    modifyFail: '修改失败',
    cancelSuccess: '取消成功',
    cancelFail: '取消失败',
    verifySuccess: '验证码发送成功',
    verifyFail: '验证码发送失败',
    submitFail: '提交失败',
    pleaseSelectPerson: '请选择分配人员',
    newLading: '新建提货单',
    prepayFreight: '预付运费',
    cancelShipment: '取消发货',
    confirmCancelShipment: '确认取消发货单？',
    confirmCancelShipmentEn: 'Confirm to cancel lading?',
    ladingNo: '提货单号',
    ladingNoLabel: '提货单号：',
    warehouse: '所属仓库',
    warehouseOrderNo: '云仓出库单号',
    submitTime: '提交时间',
    sendStatus: '发货状态',
    sendStatusCol: '发货状态',
    prepaidFreight: '预付运费',
    extractNum: '提货数量',
    sendNum: '发货数量',
    pleaseEnterLadingNo: '请输入提货单号',
    pleaseSelectProductType: '请选择商品类型',
    pleaseSelectWarehouse: '请选择仓库',
    pleaseSelectSendStatus: '请选择发货状态',
    pleaseEnterWarehouseOrderNo: '请输入云仓单号',
    addApply: '+新增申请',
    modify: '修改',
    audit: '审核',
    childDeviceExport: '子女样机列表导出',
    applyNo: '申请编号',
    agentId: '代理商ID',
    agentName: '代理商名称',
    teacherName: '教师姓名',
    teacherPhone: '教师手机',
    childName: '子女姓名',
    teacherCertNo: '教师证编号',
    auditStatus: '状态',
    createByName: '创建人',
    creator: '创建人',
    auditTime: '审核时间',
    auditor: '审核人',
    auditBy: '审核人',
    auditRemark: '审核备注',
    regionAgentId: '审核区代ID',
    regionAgentName: '审核区代名称',
    orderNo: '订单编号',
    pleaseEnterApplyNo: '请输入申请编号',
    pleaseEnterTeacherName: '请输入教师姓名',
    pleaseEnterTeacherPhone: '请输入教师手机',
    pleaseEnterTeacherCertNo: '请输入教师证编号',
    pleaseSelectStatus: '请选择状态',
    pleaseEnterOrderNo: '请输入订单编号',
    searchByDeviceSN: '根据设备SN进行搜索',
    deviceSNCol: '设备SN',
    pendingAudit: '待审核',
    auditPassed: '审核通过',
    auditRejected: '审核退回',
    auditReject: '审核回退',
    applyAgent: '申请代理商',
    regionAgent: '审核区代',
    applyRemarkLabel: '申请备注',
    createTimeLabel: '创建时间',
    teacherCertMaterial: '教师证及教师身份证明材料',
    commitment: '承诺书',
    auditResult: '审核结果',
    pleaseEnterApplyRemark: '请填写申请备注',
    pleaseEnterAuditRemark: '请填写审核备注',
    pleaseSelectAuditResult: '请选择审核结果',
    clickUploadImage: '点击上传图片',
    previewFile: '预览文件',
    deleteFile: '删除文件',
    pleaseUploadFile: '请上传文件',
    pleaseEnterChildName: '请输入子女姓名',
    batchNo: '批次号',
    pleaseEnterBatchNo: '请输入批次号',
    pleaseEnterDeviceSN: '请输入设备SN码',
    pleaseEnterProductName: '请输入商品名称',
    receiveInfo: '收货信息',
    pleaseEnterNamePhoneAddress: '请输入姓名/手机号/地址',
    dispatchDate: '发货日期',
    expressCompany: '快递公司',
    pleaseEnterExpressCompany: '请输入快递公司',
    pleaseEnterExpressNo: '请输入快递单号',
    logisticsStatus: '物流状态',
    receiveBy: '收货人',
    receiveMobile: '收货人手机',
    receiveAddressLabel: '收货地址:',
    orderQuantityLabel: '订购数量:',
    deliveredQuantityLabel: '已发数量:',
    manufacturerLabel: '厂商:',
    provinceCityLabelShort: '所在省市:',
    batchNoLabel: '批次号:',
    deviceInfoLabel: '设备信息:',
    pleaseFillExpressNo: '请填写快递单号',
    pleaseFillBatchNo: '请填写批次号',
    pleaseFillSN: '请填写SN码',
    pleaseSelectDeviceInfo: '请选择设备信息',
    shipmentExport: '发货信息导出',
    shipmentImport: '发货信息导入',
    deliver: '发货',
    batchImport: '批量导入',
    uploadDoc: '上传文档',
    dataValidate: '数据校验',
    importData: '导入数据',
    complete: '完成',
    step1Tip1: '1、模板中的表头名称及采购单信息不可更改，表头行不能删除',
    step1Tip2: '2、一个采购单发货多台设备，复制采购单信息，每台设备一行记录',
    step1Tip3: '3、采购单ID、采购单号判断为唯一采购单信息',
    step1Tip4: '4、导入表格请不要超过1000行',
    step1Title: '选择需要导入的文件，并开始导入',
    dragOrClick: '将文件拖到此处，或',
    clickUpload: '点击上传',
    dataValidating: '数据正在校验，请稍等',
    dataRetrieved: '数据检索完毕，共',
    orderInfo: '条订单信息',
    errorInfo: '内容错误信息',
    errorInfoTip: '条，请修正后重新尝试',
    errorFileDownload: '详情错误信息可下载表格查看',
    errorFileXls: '错误信息提示.xls',
    importingData: '数据导入中，当前页面可关闭，系统将自动完成导入。',
    importComplete: '导入完成，点击查看',
    upload: '上传',
    importDetail: '导入详情',
    purchaseNo: '采购单号',
    pleaseEnterPurchaseNo: '请输入采购单号',
    orderStatus: '订单状态',
    pleaseSelectOrderStatus: '请选择订单状态',
    lastDispatchTime: '最后发货时间',
    buyNum: '采购量',
    receiveNum: '发货数量',
    onlyXlsXlsx: '仅支持.xls和.xlsx格式的文件',
    confirmImport: '确定导入',
    done: '完成',
    warningDataError: '警告：仍有数据错误',
    partialErrorTip: '部分数据错误，若确认导入，错误数据不会导入到系统',
    noValidData: '没有一条符合上传的数据',
    saveSuccess: '保存成功',
    saveFail: '保存失败',
    confirmSuccess: '确认成功',
    confirmFail: '确认失败',
    campusId: '代理商ID',
    purchaseId: '采购ID',
    manufacturer: '生产厂商',
    orderCreateTime: '下单时间',
    snCodeLabel: '设备SN码：',
    snCodePlaceholder: '请输入设备SN码',
    productTypeLabel: '商品类型',
    productTypePlaceholder: '请选择商品类型',
    productName: '商品名称',
    pleaseSelectAgent: '请选择代理商',
    agentPlaceholder: '请选择代理商',
    accountStatusLabel: '账户状态：',
    accountStatusPlaceholder: '请选择账户状态',
    notActivated: '未激活',
    activated: '已激活',
    frozen: '冻结',
    subscribed: '已订阅',
    activateDateLabel: '账户激活日期：',
    expressCompanyPlaceholder: '请选择快递公司',
    expressNoLabel: '快递单号：',
    expressNoPlaceholder: '请选择快递单号',
    logisticsStatusPlaceholder: '请选择物流状态',
    stockStatusLabel: '库存状态：',
    stockStatusPlaceholder: '请选择库存状态',
    notOut: '未出库',
    out: '已出库',
    purchaseNoLabel: '采购单号:',
    remarkPlaceholder: '备注',
    remarkLabel: '备注:',
    sealStatus: '封存状态',
    accountStatus: '账户状态',
    deviceStatus: '设备状态',
    stockStatus: '库存状态',
    deviceActivateTime: '设备激活时间',
    accountActivateTime: '账户激活时间',
    agentIdLabelForm: '代理商ID：',
    agentNameLabelForm: '代理商名称：',
    warehouseLabel: '所属仓库：',
    receiverLabel: '收货人：',
    receiverPhoneLabel: '收货人电话：',
    provinceCityLabel: '省市区：',
    receiverAddressLabel: '收货地址：',
    pleaseEnterCampusAddress: '请输入校区地址',
    remarkLabelForm: '备注：',
    pleaseEnterRemark200: '请输入备注，200字以内',
    selectAddGoods: '+选择添加商品',
    addGoods: '添加商品',
    confirmDelete: '确认删除吗？',
    pleaseSelectWarehouseRule: '请选择所属仓库',
    pleaseEnterReceiverRule: '请输入收货人',
    phoneRequiredRule: '手机号不能为空',
    pleaseEnterValidPhone: '请输入正确的手机号',
    pleaseSelectProvinceCityRule: '请选择省市区',
    pleaseEnterReceiverAddress: '请输入收货地址',
    deliveryProductName: '商品名称',
    inventory: '库存量',
    warehouseAvailableStock: '仓库可用库存',
    tidanhao: '提货单号',
    createBy: '创建人：',
    goodsInfo: '商品信息',
    logisticsInfo: '物流信息',
    dispatchDateLabel: '发货日期',
    expressCompanyLabel: '快递公司',
    logisticsStatusLabel: '物流状态',
    deleteSuccess: '删除成功！',
    pleaseSelectWarehouseFirst: '请选择仓库信息',
    receiverAddressMin8: '收货地址不满8个汉字，请修改',
    pleaseSelectGoodsFirst: '请先选择商品',
    extractNumExceedInventory: '提货数量不能大于仓库可用库存',
    addBarter: '+新增换货',
    payment: '支付',
    more: '更多',
    cancelConfirm: '取消确认',
    shipInProductName: '换入商品名称:',
    shipInSwapNum: '换入商品数量:',
    shipOutProductName: '换出商品名称:',
    shipOutSwapNum: '换出商品数量:',
    barterPriceDiff: '换货差价:',
    cancelBarterTip: '是否确认取消，一旦取消后，该换货申请将作废，不可恢复，如需要可以重新创建换货申请！',
    tip: '提示',
    paymentDeductionTip: '本次支付将扣除：',
    cashAccount: '现金账户',
    goldAccount: '金账户',
    deliveryVoucherAccount: '提货券帐户',
    gotIt: '我知道了',
    paySuccessAmount: '成功支付{symbol}{money}{unitSuffix}',
    payFailAmount: '未能成功支付{symbol}{money}{unitSuffix}',
    paySuccess: '支付成功',
    payFail: '支付失败',
    paymentFail: '付款失败',
    paymentSuccess: '付款成功',
    barterStatus: '换货状态',
    priceDiffAmount: '应补差价金额',
    paidAmount: '已支付金额',
    payStatus: '支付状态',
    applyAgentId: '申请代理商ID',
    applyAgentName: '申请代理商名称',
    shipOutProductNameCol: '换出商品名称',
    shipOutSwapNumCol: '换出商品数量',
    barterOrderNoCol: '换货单号',
    productLevel: '单价级别',
    shipOutSendStatus: '换出商品发货状态',
    shipOutSendStatusLabel: '换出商品发货状态',
    swapAgentId: '换货代理商ID',
    swapAgentName: '换货代理商名称',
    shipInProductNameCol: '换入商品名称',
    shipInSwapNumCol: '换入商品数量',
    shipInSendStatus: '换入商品发货状态',
    shipInSendStatusLabel: '换入商品发货状态',
    barterOrderNo: '换货单号',
    pleaseEnterBarterOrderNo: '请输入换货单号',
    pleaseSelectBarterStatus: '请选择换货状态',
    shipOutSendStatusPlaceholder: '换出商品发货状态',
    shipInSendStatusPlaceholder: '换入商品发货状态',
    applyWarehouse: '申请方收货仓库',
    pleaseSelectApplyWarehouse: '请选择申请方收货仓库',
    swapWarehouse: '换货方收货仓库',
    pleaseSelectSwapWarehouse: '请选择换货方收货仓库',
    warehouseOrderNoInput: '云仓发货单号',
    pleaseEnterCloudWarehouseDispatchOrderNo: '请输入云仓发货单号',
    rangeSeparator: '至',
    pleaseSelectPayStatus: '请选择支付状态',
    voucherBonusAccount: '裂变奖金账户',
    childDeviceListExport: '子女样机列表导出',
    applyInfo: '申请信息',
    swapInfo: '换货信息',
    receiveWarehouse: '收货仓库',
    pleaseSelectReceiveWarehouse: '请选择收货仓库',
    pleaseEnter: '请输入',
    detailAddress: '详细地址：',
    pleaseEnterDetailAddress: '请输入详细地址',
    warehouseOrderNoLabel: '云仓单号：',
    shipStatusLabel: '发货状态：',
    barterLogisticsNoLabel: '物流单号：',
    selectSwapOutProduct: '+选择换出商品',
    snCodeCol: 'SN码',
    swapOutTotalAmount: '换出商品合计金额：',
    swapAgentLabel: '换货代理商：',
    pleaseSelectSwapAgent: '请选择换货代理商',
    selectSwapInProduct: '+选择换入商品',
    swapInTotalAmount: '换入商品合计金额：',
    selectSwapOutProductTitle: '选择换出商品',
    swapOutProductModel: '换出商品型号',
    pleaseSelectProductModel: '请选择商品型号',
    differentPriceCannotMerge: '**不同单价的商品，不可合并换货**',
    pleaseEnterSnCode: '请输入SN码',
    transferPending: '待选',
    transferSelected: '已选',
    selectSwapInProductTitle: '选择换入商品',
    swapInProductModel: '换入商品型号：',
    productSwapableQty: '商品可换数量：',
    swapQtyLabel: '换货数量：',
    pleaseEnterQty: '请输入数量',
    swapOutProductModelLabel: '换出商品型号：',
    priceDiffAmountLabel: '应补差价金额：',
    paidAmountLabel: '已支付金额：',
    barterOrderNoLabel: '换货单号：',
    barterStatusLabel: '换货状态：',
    remarkLabelBarter: '备注：',
    remarkPlaceholder200: '请输入200字以内的备注信息',
    auditRemarkLabelBarter: '审核备注：',
    auditResultLabel: '审核结果：',
    agree: '同意',
    reject: '拒绝',
    auditOpinionLabel: '审核意见：',
    auditOpinionPlaceholder: '请输入100字以内的审核意见',
    pleaseEnterAuditOpinion: '请输入审核意见',
    yuan: '元',
    pleaseEnterReceiverType: '请输入{type}收货人',
    pleaseEnterReceiverPhoneType: '请输入{type}收货人电话',
    pleaseSelectProvinceCityType: '请选择{type}省市区',
    pleaseEnterDetailAddressType: '请输入{type}详细地址',
    warehouseSameTip: '换入/换出的收货仓库必须保持一致，如果是云仓，请保持同地的云仓！',
    priceDiffTip: '应补款金额必须低于换出商品的单价，且大于等于0，请调整交换商品的数量后重新保存',
    headquarterSwapTip: '与总部换货"总部回购商品"，应补差价必须为0',
    pleaseSelectSwapOutFirst: '请先选择换出商品',
    swapQtyMin1: '换货数量不能小于1',
    swapQtyExceedTotal: '换货数量不能大于该商品在该仓库的可换数量',
    pleaseFillComplete: '请填写完整信息',
    warehouseChangeSwapOutTip: '收货仓库改变，下方已选择的换出商品将全部清空，请重新选择，是否继续修改收货仓库！',
    warehouseChangeSwapInTip: '收货仓库改变，下方已选择的换入商品将全部清空，请重新选择，是否继续修改收货仓库！',
    swapAgentChangeTip: '换货代理商改变，下方已选择的换入商品将全部清空，请重新选择，是否继续修改换货代理商！',
    applyParty: '申请方',
    swapParty: '换货方',
    operationSuccess: '操作成功',
    pleaseSelectDeviceToSelected: '请选择设备到已选区！',
    differentModelCannotMerge: '不同型号或单价的商品不可合并换货',
    pleaseSelectExchangeOut: '请选择换出商品',
    pleaseSelectExchangeIn: '请选择换入商品',
    applyShipWarehouse: '申请方发货仓库',
    swapShipWarehouse: '换货方发货仓库',
    applyReceiver: '申请方收货人',
    swapReceiver: '换货方收货人',
    shipOutExpressNo: '换出商品快递单号',
    shipInExpressNo: '换入商品快递单号',
    shipOutProductShip: '换出商品发货',
    shipInProductShip: '换入商品发货',
    pleaseEnterFullExpressNo: '请输入完整快递单号',
    shipSuccess: '发货成功',
    pleaseEnterProductExpressNo: '请输入商品快递单号',
    shipIn: '换入',
    shipOut: '换出',
    receiveConfirmTitle: '商品收货确认',
    receiveConfirmCheck: '收货确认：型号、数量SN码完全一致',
    refuseAccept: '拒绝接受：',
    pleaseEnterRefuseReason: '请输入拒绝原因',
    receiveConfirmTip: '一旦收货确认，换货商品sn码将转入换货方，且不可退回！',
    pleaseCheckVerify: '请勾选核对项！',
    shipInOutExpressNo: '商品快递单号：',
    shipInOutStatus: '商品发货状态：',
    warehouseShipOrderNo: '云仓发货单号：',
    payTitle: '付款',
    freightAmountLabel: '运费',
    relatedAgent: '关联代理商',
    deliveryVoucherLabel: '提货券账户',
    accountBalance: '账户余额',
    relatedAgentBalance: '关联代理账户余额',
    availableAmount: '可用金额',
    remainingPayAmount: '剩余支付金额',
    payMethod: '支付方式',
    bankTransfer: '对公转账',
    transferAmount: '转账金额',
    payTimeLabel: '支付时间',
    payTimeRequired: '支付时间不能为空',
    pleaseSelectPayTime: '请选择支付时间',
    paySerialNo: '支付流水',
    pleaseEnterPaySerialNo: '请输入支付流水',
    payVoucher: '支付凭证',
    payVoucherRequired: '支付凭证不能为空',
    payVoucherTip: '支持jpg/png格式，最佳尺寸1080x1920，大小不超过5MB',
    credentialInstance: '凭证实例',
    payRemark: '支付备注',
    pleaseEnterPayRemark: '请输入支付备注',
    bankAccount: '银行账号',
    bankName: '开户行',
    buyNumLabel: '采购量',
    orderAmountLabel: '采购金额',
    paidAmountReal: '实付金额',
    freightPlan: '运费方案',
    plan1FreightCollect: '方案一: 运费到付',
    plan1FreightTip: '（收货后支付给配送员，实际金额可能会有20%的浮动，以实际为准）',
    plan2FreightPrepay: '方案二: 运费预付',
    plan2FreightTip: '（原价{amount}元，与订货款一起支付，出现争议由总部负责）',
    chargeItem: '收费项目',
    unitPrice: '单价',
    quantity: '数量',
    amount: '金额',
    discount: '折扣',
    amountAfterDiscount: '优惠后的金额',
    freightOrderTip: '本订单采购数量不足10台，按公司快递规则是: 到付;为了让大家享受邮费打折的优惠，现提供预付到付运费的服务，请注意:',
    freightRule1: '1、到付运费折扣以公司与京东仓签订的折扣为准，目前折扣: 6.5折，以后如有变化，会及时通知;',
    freightRule2: '2、预收到付运费自愿选择，如果放弃预付运费所享受的折扣，须在签收时支付到付运费给快递公司，具体支付金额和方式以快递公司为准;',
    freightRule3: '3、预收到付运费收取后，如果此订单与其他订单合并配送，满足免运费条件(数量大于等于10台)，完成后，自动退还预收运费;',
    payFreightCollect: '支付(运费到付)',
    payFreightPrepay: '支付(运费预付)',
    pleaseDoNotOperateTooFrequently: '请勿操作过于频繁',
    qrCodeGenerating: '二维码生成中...',
    scanWithAlipay: '使用支付宝扫一扫',
    scanWithWechat: '使用微信扫一扫',
    qrCodeUrlInvalid: '二维码地址不正确',
    payAmountYuan: '支付{symbol}{amount}{unitSuffix}',
    unitTai: '台',
    markPrototype: '标记样机',
    prototypeAccountRenewal: '样机账户续期',
    accountPhoneRebind: '账户手机换绑',
    unmarkPrototype: '取消样机标记',
    prototypeMark: '样机标记',
    productModel: '商品型号',
    prototypeType: '样机类型',
    pleaseSelectPrototypeType: '请选择样机类型',
    shippedPrototypeCount: '已发货样机数',
    markedPrototypeCount: '商品标记样机数',
    markablePrototypeCount: '可标记样机数',
    save: '保存',
    prototypeRenewalApply: '样机账户续期申请',
    prototypeSN: '样机SN码',
    currentCertArea: '当前认证区域',
    accountActiveTime: '账户激活时间',
    accountValidPeriod: '账户有效期',
    renew: '续期',
    machineAccountNo: '学习机账户编号',
    confirmUnmarkPrototype: '确认要取消样机标记？',
    searchStudent: '搜索学员',
    accountActiveDate: '账户激活日期',
    pleaseEnterMachineAccount: '请输入学习机账户',
    pleaseEnterStudentAccountName: '请输入学院账号、学员姓名',
    accountValidDate: '账户有效期',
    studentAccount: '学生账号',
    studentName: '学生姓名',
    campusName: '校区名称',
    schoolId: '校区ID',
    schoolName: '校区名称',
    prototypeNote1: '1、学习机一旦标记为样机，将不可修改；',
    prototypeNote2: '2、样机不可用于销售，仅作体验和展示用途；',
    prototypeNote3: '3、每台样机只能绑定一个学习账号，已绑定多个学习账号的设备标记为样机，必须选择保留的账号，其他账号将与学习机解绑；',
    prototypeMarkOnceTip: '学习机一旦标记为样机，将不可修改',
    pleaseVerifyDeviceSN: '请先验证设备SN码',
    pleaseSelectStudent: '请选择学员',
    markSuccess: '标记成功',
    renewSuccess: '续费成功',
    renewFail: '续费失败',
    pleaseEnterNewPhone: '请输入新手机号',
    pleaseEnterVerifyCode: '请输入验证码',
    rebindSuccess: '换绑成功',
    rebindFail: '换绑失败',
    add: '新增',
    jdSendParamExport: '京东仓发货参数配置导出',
    jdSend: '京东仓发货',
    printDeliveryOrder: '打印发货单',
    adjustDispatchType: '调整发货方式',
    adjustDispatchTypeTo: '调整发货方式为：',
    pleaseSelectDispatchType: '请选择发货方式',
    confirmCancel: '确认取消吗？',
    regionAgentLabel: '发货区域代理',
    receiverInfo: '收货人信息',
    pleaseEnterReceiverInfo: '请输入收货人信息',
    tmallOrderNo: '天猫订单编号',
    pleaseEnterTmallOrderNo: '请输入天猫订单编号',
    confirmBy: '确认人',
    shipRegionAgentId: '发货区代ID',
    shipRegionAgentName: '发货区代名称',
    saleShipmentExport: '销售发货导出',
    shipWarehouse: '发货云仓',
    pleaseSelectJdCloudShipWarehouse: '请选择发货云仓',
    pleaseSelectShipWarehouse: '请选择发货仓',
    jdProductName: '京东商品名称',
    pleaseEnterJdProductName: '请输入京东商品名称',
    waitSendNumCol: '待发货数量',
    agentWarehouseName: '代理商收货仓',
    provinceCity: '省市区',
    receiverAddress: '收货人地址',
    shipWarehouseCol: '发货仓',
    relatedOrder: '关联订单',
    pleaseEnterRelatedOrder: '请输入关联订单',
    sendTime: '发货时间',
    sentNum: '已发货数量',
    logisticsCompany: '物流公司',
    logisticsNo: '物流单号',
    pleaseEnterLogisticsNo: '请输入物流单号',
    orderDeliveryStatus: '订单发货状态',
    pleaseSelectOrderDeliveryStatus: '请选择订单发货状态',
    pleaseEnterShipmentNo: '请输入发货单号',
    transferOrderNo: '调拨单号',
    expressNo: '快递单号',
    shipStatus: '发货状态',
    pleaseSelectShipStatus: '请选择发货状态',
    cancelBy: '取消人',
    cancelTime: '取消时间',
    confirmCancelShip: '确认取消发货吗?',
    pleaseEnterTransferOrderNo: '请输入调拨单号',
    paramType: '参数类型',
    paramValue: '参数值',
    condition: '条件',
    pleaseSelectProduct: '请选择商品',
    pleaseSelectParamType: '请选择参数类型',
    pleaseSelectParamValue: '请选择参数值',
    pleaseEnterMinValue: '请输入最小值',
    pleaseEnterMaxValue: '请输入最大值',
    deliveryQty: '发货数量',
    unit: '台',
    deleteConfig: '删除',
    confirmDeleteConfig: '确认删除该条配置吗？',
    addJdSendParam: '新增京东仓发货参数配置',
    editJdSendParam: '修改京东仓发货参数配置',
    agentLabel: '代理商',
    productLabel: '商品',
    mailPayMark: '邮寄付费标记',
    deleteSuccessMsg: '删除成功',
    deleteFailMsg: '删除失败',
    saveSuccessMsg: '保存成功',
    saveFailMsg: '保存失败',
    pleaseSelectDeliveryOrder: '请选择发货单',
    generateDeliveryOrderSuccess: '生成发货单成功！',
    adjustDispatchTypeSuccess: '调整发货方式成功！',
    pleaseFillManualAllocationInfo: '请输入人工分配完整信息后保存',
    pleaseSelectPaymentMethod: '请选择以下支付方式支付剩余金额',
    insufficientBalanceRecharge: '账户余额不足，请先去充值。',
    snDuplicateCheck: 'SN码重复，请检查确认！',
    currentSnExists: '当前SN码已存在！',
    pleaseEnterDeviceInfo: '请录入设备信息',
    order: '天猫订单编号:',
    ship: '部分发货',
    time: '账户激活时间',
    danhao: '快递单号',
    device: '设备SN码：',
    already: '已申请',
    name: '下级代理商名称',
    info: '收货信息：',
    chudanhao: '云仓出库单号',
    consignee: '收货人',
    shouji: '收货人手机',
    address: '收货人地址',
    mobile: '请输入姓名/手机号/地址',
    queren: '收货确认',
    pending: '待申请',
    purchase: '采购单号',
    num: '发货数量',
    dianhua: '收货人电话',
    activate: '已激活',
    not: '未出库',
    jidailiqu: '下级代理所属区域',
    dinghao: '订阅卡卡号',
    qing: '不可申请',
    buyTime: '购买日期',
    validTime: '有效日期',
    headOfficeDispatchOrderStatus6068002: '已确认',
    headOfficeDispatchOrderStatus6068010: '发货中',
    headOfficeDispatchOrderStatus6068007: '已发货',
    headOfficeDispatchOrderStatus6068009: '部分发货',
    headOfficeDispatchOrderStatus6068008: '收货确认',
    headOfficeDispatchOrderStatus6068013: '拒收待发出',
    headOfficeTransferColOrderQty: '订单数量',
    headOfficeTransferColOrderAmount: '订单金额',
    headOfficeTransferColShipOrderNo: '发货单号',
    areaConsignmentShipStatusValid: '有效',
    areaConsignmentShipStatusCancelled: '已取消',
  }
}
